if (!customElements.get('box-selector')) {
  class BoxSelector extends HTMLElement {
    constructor() {
      super();

      this.bonbonsBar = document.querySelector('bonbons-bar');
      this.boxSizeInput = this.bonbonsBar?.boxSizeInput;
      this.currentBoxSize = this.boxSizeInput?.value;
      this.itemsWrapper = this.querySelector('[data-items-wrapper]');
      this.tracker = this.querySelector('[data-tracker]');
      this.nav = this.querySelector('[data-nav]');
      this.prevBtn = this.nav.querySelector('[data-button-prev]');
      this.nextBtn = this.nav.querySelector('[data-button-next]');

      this.addEventListener('change', (e) => {
        this.updateTracker();

        if (!this.bonbonsBar) return;

        if (this.bonbonsBar.classList.contains('is-edit')) {
          this.bonbonsBar.classList.toggle(
            'is-confirm',
            this.currentBoxSize !== e.target.dataset.boxSize,
          );
          this.boxSizeInput.value = e.target.dataset.boxSize;
          this.updateBonbonsState();

          return;
        }

        this.currentBoxSize = e.target.dataset.boxSize;

        this.updateBoxSizeInput();
      });

      if (this.bonbonsBar) {
        this.boxSizeInput.addEventListener('change', (e) => {
          this.currentBoxSize = e.target.value;

          this.updateSelector();
          this.updateTracker();
        });
      }

      this.initTracker();
    }

    updateBonbonsState() {
      this.bonbonsBar.slider.slides.forEach((slide, index) => {
        slide.classList.toggle(
          'is-disabled',
          index >= +this.boxSizeInput.value,
        );
      });
    }

    updateSelector() {
      const matchingInput = this.getMatchingInput();

      matchingInput.checked = true;
    }

    updateBoxSizeInput() {
      this.boxSizeInput.value = this.currentBoxSize;

      const matchingInput = this.getMatchingInput();

      this.bonbonsBar.variantIdInput.value = matchingInput.dataset.variantId;
      this.boxSizeInput.dispatchEvent(new Event('change'));
    }

    getMatchingInput() {
      return this.querySelector(
        `input[data-box-size="${this.currentBoxSize}"]`,
      );
    }

    getCheckedInput() {
      return this.querySelector('input:checked');
    }

    initTracker() {
      requestAnimationFrame(() => {
        this.tracker.style.transition = 'none';
        this.nav.style.transition = 'none';
        this.updateTracker();

        requestAnimationFrame(() => {
          this.tracker.style.transition = '';
          this.nav.style.transition = '';
        });
      });

      this.trackerResizeObserver = new ResizeObserver(() =>
        this.updateTracker(),
      );
      this.trackerResizeObserver.observe(this.itemsWrapper);

      this.prevBtn.addEventListener('click', () => this.navigate('previous'));
      this.nextBtn.addEventListener('click', () => this.navigate('next'));
    }

    updateTracker() {
      const input = this.getCheckedInput();
      const label = input.nextElementSibling;
      const wrapperRect = this.itemsWrapper.getBoundingClientRect();
      const labelRect = label.getBoundingClientRect();
      const labelCenter =
        labelRect.left - wrapperRect.left + labelRect.width / 2;
      const offsetLeft = labelCenter - this.tracker.offsetWidth / 2;

      this.tracker.style.transform = 'translateX(' + offsetLeft + 'px)';
      this.nav.style.transform = 'translateX(' + offsetLeft + 'px)';

      this.prevBtn.disabled = !input.closest('li').previousElementSibling;
      this.nextBtn.disabled = !input.closest('li').nextElementSibling;
    }

    navigate(direction) {
      const input = this.getCheckedInput();
      const sibling = input.closest('li')[direction + 'ElementSibling'];
      if (!sibling) return;
      const nextInput = sibling.querySelector('input[type="radio"]');
      nextInput.checked = true;
      nextInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  customElements.define('box-selector', BoxSelector);
}
